<template>
    <div class="w-100 h-auto">
        <CartNotification
            v-if="globalSiteEvent && !isDesktop && cartNotification"
            :class="{'shrink': cartNotification && cartNotification.animationState === 'shrink','shrink jump': cartNotification && cartNotification.animationState === 'jump'}"
            :notification-data="cartNotification"
            @fademe="resetNotification"
        />
        <section v-if="groupIdList" class="multi-cart modal-wrapper" :class="{ 'mobile-wrapper' : !isDesktop }" id="multiCartModalWrapper" @click.self="close()">
            <div class="modal-container" :class="{ 'solo-cart' : !buildingList && productStatusList.length == 1 }" id="multiCartModalContainer">
                <MuffinLoader v-if="isLoading" :class="{ 'full-page' : !isDesktop}"/>
                <div class="modal-header" @click="!isDesktop && close()">
                    <div v-if="!isDesktop" class="mobile-header-close"/>
                    <p class="header-title"> {{ kStrings.kCHOOSE_YOUR_PRODUCTS_OPTIONS }} </p>
                    <i v-if="isDesktop" class="ecom-close" @click="close()"/>
                </div>
                <div class="row mx-0 modal-body" :class="{ 'themed-scrollbar' : isDesktop }">
                    <div v-if="!buildingList && productsCartData" v-for="(prod, index) in productsCartData" class="combo-item-container multi-item-container col-pad-6" :class="{ 'disabled-cart' : !checkCartItemEnabled(prod.data.productInfo.groupId)}">
                        <QuickCart
                            :pre-loaded-product-data="prod.data"
                            :key="prod.data.productInfo.groupId"
                            :group-id="prod.data.productInfo.groupId"
                            :multi-cart-mode="true"
                            :horizontal-prod-image="!isDesktop"
                            :class="{ 'mobile-style' : !isDesktop }"
                            @update-product="updateProduct"
                            @toggle-product="toggleProduct"
                        />
                    </div>
                </div>
                <div class="detailed-shadow"/>
                <div class="row mx-0 modal-footer">
                    <div v-if="!isLoading && priceData" class="price-multi-container" :class="[ isDesktop ? 'col-auto p-0' : 'w-100' ]">
                        <span class="price-desc"> {{ kStrings.kGLOB_TOTAL + ':' }} </span>
                        <div class="price-row">
                            <p v-if="priceData.totalCrossed" class="price crossed"> {{ priceData.totalCrossed }} </p>
                            <p class="price"> {{ priceData.total }} </p>
                        </div>
                    </div>
                    <div class="buttons-container" :class="[ isDesktop ? 'col-auto p-0 ml-auto' : 'w-100' ]">
                        <button v-if="isDesktop" class="button-white" @click="close()" data-mub-skip="y"> {{ kStrings.kCANCEL }} </button>
                        <button data-mub-skip="y" class="button-dark"  :class="{ 'cart-warning' : cartWarning }" @click="multiAddToCart" :disabled="!enableBuyButton">
                            <i v-if="cartWarning" class="ecom-info"/>
                            {{ buyButtonText }}
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

import {isEmpty, sortBy} from 'lodash-es';
import request from '@/Utilities/httpRequest';
import utilities from '@/Utilities/common';
import operatingSystem from '@/Utilities/operating-system';
//import websiteEvents from '@/Utilities/website-events';
import {store} from '@/store/multiCart';

import MuffinLoader from '@/components/Muffin/Loader';
import sharedApi from '@/api/sharedApi';
import apiCart from '@/api/cart';

import QuickCart from '@/components/ComboCart/QuickCart';
import CartNotification from '@/components/AddToCart/partials/notifications/CartNotification.vue';
import apiCatalog from '@/api/catalog';

export default {
    store,
    name: 'MultiCartPopup',
    components: {
        MuffinLoader,
        QuickCart,
        CartNotification,
    },
    props: {
        multiCartData: {type: Object, default: null, required: true},
        webEventValue: {type: String, default: 'GENERAL_CART'},
        globalSiteEvent: {type: Boolean, default: false}
    },
    data() {
        return {
            buildingList: false,
            productStatusList: []
        }
    },
    computed: {
        allSkusOK() {
            if(isEmpty(this.productStatusList)) {
               return false; 
            }
            let enabledList = this.productStatusList.filter(elem => elem.enabled);
            return !isEmpty(enabledList) ? enabledList.every(elem => elem.selectedSku && elem.stock > 0) : false;
        },
        buyButtonText() {
            if(this.cartWarning) {
                return this.cartWarning;
            }
            
            return this.productStatusList.length > 1 ? this.kStrings.kGLOB_ADD_PRODUCTS : this.kStrings.kADD_PRODUCT_RECIPES ; 
        },
        cartSkus() {
            if(!isEmpty(this.productStatusList)) {
                return this.productStatusList.map(elm => elm.enabled ? {
                    sku: elm.selectedSku,
                    quantity: elm.qty,
                    type: 0,
                    addQty: true
                } : null).filter(e => e);
            }

            return [];
        },
        cartNotification() {
            return this.$store.getters.cartNotification;
        },
        cartWarning() {
            return this.isDesktop ? this.$store.getters.cartWarning : null;
        },
        enableBuyButton() {
            return this.allSkusOK && !this.cartWarning && !this.isLoading;
        },
        groupIdList() {
            return this.$store.getters.groupIdList;
        },
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        isLoading() {
            return this.$store.getters.isLoading;
        },
        isLogged() {
            return this.$store.getters.isLogged;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        priceData() {
            if(!isEmpty(this.productStatusList)) {
                let total = 0;
                let totalCrossed = 0;
                this.productStatusList.forEach((elem, index) => {
                    if(elem.enabled) {
                        total += elem.price ? elem.price : 0;
                        totalCrossed += elem.priceCrossed ? elem.priceCrossed : elem.price;
                    }
                });
                
                return {
                    total: typeof App !== 'undefined' ? App.js.formatPrice(total) : total.toFixed(2),
                    totalCrossed:  totalCrossed > 0 && (total != totalCrossed) ? (typeof App !== 'undefined' ? App.js.formatPrice(totalCrossed) : totalCrossed.toFixed(2)) : null
                }
            }
            
            return null;
            
        },
        productsCartData() {
            return !isEmpty(this.$store.getters.productsCartData) ? sortBy(this.$store.getters.productsCartData, 'index') : null;
        },
        urls() {
            return this.$store.getters.urls;
        },
        mubRawData(){
            const data = this.$store.getters.mubData;
            let mub = data && data[this.comboId] ? data[this.comboId] : null;
            if(mub){
                // force "no observer"
                mub['obs'] = false;
                // force target as "add to cart"
                mub['ta'] = 'a2c';
            }
            return mub;
        }
    },
    watch: {},
    mounted() {
        this.$nextTick(() => {
            apiCatalog.loadStyleSheet(this.multiCartData.multicartCss, 'multicartCss');
            this.setup(this.multiCartData);
            //if(!this.isDesktop) {
            utilities.disableBodyScroll(true);
           /* if(this.multiCartData.isApp) {
                this.eventModalApp(true);
            }*/
            
            //}
            //websiteEvents.eventMultiCart('open', this.webEventValue, {groupIdList: this.groupIdList});
            let body = document.body;
            if(body) {
                body.classList.add('modal-open');
                if(this.multiCartData.isApp) {
                    body.classList.add('app-mode');
                }
            }
            
            //console.log('list debug: ', this.groupIdList);
        });
        
    },
    destroyed() {
       /* if(!this.isDesktop) {*/
            utilities.enableBodyScroll();
       /* }*/
        let body = document.body;
        if(body) {
            body.classList.remove('modal-open');
        }
    },
    methods: {
        checkCartItemEnabled(groupId = null) {
            const prod = this.productStatusList.find(elm => elm.groupId == groupId);
            return prod && prod.enabled;
            
            //return !isEmpty(this.productStatusList.find(elm => elm.groupId == groupId && elm.enabled));
        },
       /* checkCartItemWarning(groupId = null) {
            if(!this.checkCartItemEnabled(groupId)) {
                return false;
            }
            
            return !isEmpty(this.productStatusList.find(elm => elm.groupId == groupId && (!elm.selectedSku || !elm.stock)));
        },*/
        async close(awaitCartAnim = false) {
           /* if(!this.isDesktop) {*/
                utilities.enableBodyScroll();
                //this.eventModalApp(false);
           /* }*/
            
            let body = document.body;
            if(body) {
                body.classList.remove('modal-open');
                body.classList.remove('app-mode');
            }
            //websiteEvents.eventMultiCart('close', this.webEventValue, {groupIdList: this.groupIdList});
            let multiCartModalWrapper = document.getElementById('multiCartModalWrapper');
            if(awaitCartAnim) {
                multiCartModalWrapper.style.display = 'none';
                setTimeout(() => {
                    this.$emit('close');
                }, 3000);
            } else {
                this.$emit('close');
            }
            
            if(this.globalSiteEvent) {
                multiCartModalWrapper.remove();
            }
        },
        
        // on hold
        async loadProductData(groupIdList = null) {
            this.buildingList = true;
            if(!isEmpty(groupIdList)) {
                /*let cartData = [];*/
                await Promise.all(groupIdList.map(async (element, index) => {
                    try {
                        const {data} = await request.get(this.urls.addToCartData, {id: element});
                        //console.log('RESPONSE: ', data);
                        if(!data.error && data.productInfo) {
                            /*cartData.push(data);*/
                            if(this.validateProduct(data)) {
                                this.productStatusList.push({
                                    index: index + 1,
                                    data: data,
                                    groupId: element,
                                    qty: 1,
                                    selectedSku: null,
                                    price: null,
                                    priceCrossed: null,
                                    stock: 0,
                                    enabled: true

                                });
                            }
                            
                        } else {
                            sharedApi.logError('multi cart groupId fail:  ' + element);
                        }
                    } catch (error) {
                        sharedApi.logError('multi cart product load fail' + error);
                    } finally {
                        this.$store.dispatch('setProductData', this.productStatusList);
                        //this.buildingList = false;
                    }
                }));
                
            } else {
                sharedApi.logError('multi cart product load fail' + error);
                this.buildingList = false;
            }
        },
        async multiAddToCart() {
            try {
                this.$store.dispatch('setLoading', true);
                if (!isEmpty(this.cartSkus)) {
                    const {data} = await apiCart.addToCartBulk(this.cartSkus, 0);
                    let hasError = !data || data.error;
                    if (!hasError) {
                        let numCartItems = data.cart.itemCount;
                        if (this.isDesktop) {
                            VueEs6.addToCartDesktop.cartItemNumUpdate(numCartItems);
                            VueEs6.header.miniCart.updateAndOpen();
                            //websiteEvents.eventMultiCart('added', this.webEventValue, {groupIdList: this.groupIdList});
                            this.close();
                        } else {
                            VueEs6.addToCart.cartItemNumUpdate(numCartItems);
                            let cartMessageSuccess = this.cartSkus.length == 1 ? this.kStrings.kCART_UPDATE_SUCCESS : this.kStrings.kCART_UPDATE_SUCCESS_MULTI
                            let responseError = data.error;
                            const success = !responseError ? true : false;
                            const message = !responseError ? cartMessageSuccess : this.kStrings.kSOMETHING_WRONG;
                            const actionText = !responseError ? this.kStrings.kVIEW_CART : '';
                            this.afterRequest(success, message, actionText);
                        }
                        
                    } else {
                        //let cartMsgError = data.hasOwnProperty('message') ? data.message : this.kStrings.kSOMETHING_WRONG;
                        let cartMsgError = this.kStrings.kSOMETHING_WRONG;
                        this.afterRequest(false, cartMsgError, '');
                    }
                }
            } catch (error) {
                console.log('widget has errors, please try another time :(', error);
                this.afterRequest(false, this.kStrings.kSOMETHING_WRONG, '');
            } finally {
                this.$store.dispatch('setLoading', false);
            }
        },
        async setup(data = null) {
            if(!isEmpty(data) && (data.hasOwnProperty('groupIdList') && !isEmpty(data.groupIdList))) {
                this.$store.dispatch('setLoading', true);
                await this.$store.dispatch('setWsData', data);
                await this.loadProductData(data.groupIdList);
                this.$store.dispatch('setLoading', false);
                this.buildingList = false;
            } else if(typeof Bugsnag !== 'undefined'){
                Bugsnag.notify('multi cart popup', 'error or empty ids list', {}, 'error');
            } else {
                console.log('multi cart popup load failed');
            }
        },
        toggleProduct(groupId = null) {
            if(groupId) {
                this.productStatusList = this.productStatusList.map((item) =>
                    item.groupId === groupId ? { ...item, ...{ enabled: !item.enabled}} : item
                )
            }
        },
        async updateProduct(data = null) {
            if(data) {
                this.productStatusList = this.productStatusList.map((item) =>
                    item.groupId == data.groupId ? {
                        ...item, ...{
                            groupId: data.groupId,
                            selectedSku: data.selectedSku,
                            stock: data.stock,
                            price: data.price,
                            priceCrossed: data.priceCrossed,
                            warningDescription: data.warningDescription
                        }
                    } : item
                );
               // console.log('updated list: ', this.productStatusList);
            }
        },
        afterRequest(success, message, actionText){
            //websiteEvents.eventMultiCart((success ? 'added' : 'not-added'), this.webEventValue, {groupIdList: this.groupIdList});

            if(!this.isDesktop) {
                const cartNotificationData = {
                    link: '',
                    success: success,
                    animationState: null,
                    message: message,
                    actionText: actionText,
                };
                this.$store.dispatch('setCartNotification', cartNotificationData);
                this.close(true);
            } else {
                this.$store.dispatch('setCartWarning', this.kStrings.kSOMETHING_WRONG);
            }

            /*if(success && !this.isDesktop && typeof App !== 'undefined'){
                //console.log('ComboCart afterRequest -> call App.js.callAppsJs evtNativeModalClose');
                App.js.callAppsJs('evtNativeModalClose', true);
            }*/
        },
        resetNotification() {
            this.$store.dispatch('setCartNotification', null);
        },
        validateProduct(data = null) {
            if(data) {
                let statusOk = data.productInfo.groupStatus == 'AC';
                let stockOk = !isEmpty(data.products.filter(elm => elm.stock > 0));
                return statusOk && stockOk;
            }
            
            return false;
        },
        isIOS(){
            return operatingSystem.isIOS();
        },
        isAndroid(){
            return operatingSystem.isAndroid();
        },
    }
};
</script>

<style lang="scss">
    //@import "@/styles/multicart/multicart.scss";
</style>